import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { Transaction } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  findLast(type: string, year: string): Observable<HttpResponse<Transaction[] | number>> {
    return this.http
      .get<Transaction[]>(`${environment.API_URL}/transactions/last?type=${type}&year=${year}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }
  
  find(query=''): Observable<HttpResponse<Transaction[] | number>> {
    return this.http
      .get<Transaction[]>(`${environment.API_URL}/transactions${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  findById(id: string, query = ''): Observable<HttpResponse<Transaction>> {
    return this.http
      .get<Transaction>(`${environment.API_URL}/transactions/${id}${query}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  create(body: Transaction) {
    return this.http
      .post(`${environment.API_URL}/transactions`, body, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  update(body: any) {
    return this.http
      .patch(`${environment.API_URL}/transactions/${body[0]}`, body[1], {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/transactions/${id}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

}
